<template>
<div class="row select" :class="{'value-9':this.value==-9,'value-ok':this.value!=-9 && this.value!=-127}">
      <el-select  placeholder="Selezionare" v-bind:value.sync="isvalue" v-on:change="updateValue_mirko" v-on:input="updateValue" :multiple="(item.tipo==4) ? true : false" filterable="filterable" clearable>
         <el-option v-for="itm in gruppianswer" :key="itm.id" :label="itm.nome" :value="itm.id" ></el-option>
         <el-option v-if="item.nc!=0" label="Non Conosciuto" :value="item.nc" ></el-option>
      </el-select>

      <el-select  placeholder="Selezionare" v-bind:value.sync="isvalue" v-on:change="updateValue" v-on:input="updateValue" :multiple="(item.tipo==4) ? true : false" filterable="filterable" clearable>
         <el-option v-for="itm in itemsanswer" :key="itm.id" :label="itm.nome" :value="itm.id" ></el-option>
         <el-option v-if="item.nc!=0" label="Non Conosciuto" :value="item.nc" ></el-option>
      </el-select>

      <!--  
         <div v-if="nc == -1  || item.nc==0" style="color:#B00E23;">Dato non conosciuto</div>  
      -->
      <!-- {{value}} :: {{isvalue}}  -->
</div>
</template>

<script>
export default {
   name: 'FormSelect',
   model: {
    // By default, `v-model` reacts to the `input`
    // event for updating the value, we change this
    // to `change` for similar behavior as the
    // native `<select>` element.
    event: 'change',
   },
   props: ['value','variabile'],
   data() {
      return {
         readyInterval:0
         ,isvalue: ''
      }
   },
   watch: {
      value: function(val){
         console.log("THIS.VALUE is now "+val)
         this.action4value(val)


      }
   },
   created () {
      console.log("Created form for variable "+this.variabile)

      //this.readyInterval = setInterval(() => { 
         console.log("Before action4value form for "+this.variabile+" the values is "+this.value +' and nc '+this.nc)
         if(typeof this.value != 'undefined' && this.value !==''){
            
            this.action4value((this.value==-7)?-127:this.value)
            console.log("After action4value form for "+this.variabile+" the values is "+this.value +' and nc '+this.nc)

            //clearInterval(this.readyInterval)
            //this.readyInterval = -1
         }
      //}, 1000)


      
   },
   destroyed(){
      //if( this.readyInterval != -1)
         clearInterval(this.readyInterval)
   },
   methods: {
      action4value(val){
         if(val==-127 ){
            this.isvalue = ''
         }else{
            this.isvalue = this.value
         }
      },
      updateValue_mirko(e){},
      updateValue (e) {
         console.log("UPDATED VALUE e is "+e)
         let val = -127
         switch(e){
            case 0:
            val = 0
            break;

            case '':
            val = -127
            break;

            default:
            val = e
         }
         
         console.log("UPDATED VALUE val is "+val)
         this.$emit('change', val)
      }
   },
   computed:{
      filterable:function(){
         let filterable = []
         switch(this.item.nome) {
            case 'statomadre':
            filterable = true
            break
            default:
            filterable = false
         }
         return filterable
      },
      gruppianswer: function(){
   		let isFilter = []	
         for (let item of this.$teras._anomaliecongenite){
            if(item.parente==0) 
               isFilter.push(item)
         }
         return isFilter
      },
      itemsanswer:function(){
         let items = []
         switch(this.item.nome) {
            case 'statomadre':
            items = this.$nazioni
            break
            case 'bdcd1gruppo':
            case 'bdcd1':
            case 'bdcd2':
            case 'bdcd3':
            case 'bdcd4':
            case 'bdcd5':
            items = this.$teras._anomaliecongenite
            break;
            default:
            items = JSON.parse(this.item.answer)
         }
         return items
      },
      item:function(){
         let item = this.$teras.getItemFromArrayObject(this.variabile,'nome',this.$teras._variabile)
         /*if(item.nc==this.value)
            this.nc=-1
         if(this.value!=-127 && item.nc!=this.value){
            this.nc=1
            console.log("LO CAMBIO QUI this.value è "+this.value)
         }
         */
         return item
    }
   }
}
</script>